import { render, staticRenderFns } from "./FixSmsRevisions.vue?vue&type=template&id=5ce54b26&scoped=true"
import script from "./FixSmsRevisions.vue?vue&type=script&lang=js"
export * from "./FixSmsRevisions.vue?vue&type=script&lang=js"
import style0 from "./FixSmsRevisions.vue?vue&type=style&index=0&id=5ce54b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce54b26",
  null
  
)

export default component.exports